module.exports = __webpack_public_path__ + "img/c_804.291aba0c.jpg";